import { z } from 'zod';

/**
 * Credit system types and constants.
 */

export const CreditEventTypeSchema = z.enum([
  'spend',
  'admin_grant',
  'subscription_refresh',
]);
export type CreditEventType = z.infer<typeof CreditEventTypeSchema>;

export const UserPlanSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  creditsBalance: z.number().int().min(0),
  subscriptionTier: z.string().nullable(),
  monthlyCredits: z.number().int().min(0),
  nextRefreshAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type UserPlan = z.infer<typeof UserPlanSchema>;

export const CreditLedgerEntrySchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  eventType: CreditEventTypeSchema,
  delta: z.number().int(),
  balanceAfter: z.number().int(),
  aiAction: z.string().nullable(),
  entityType: z.string().nullable(),
  entityId: z.string().uuid().nullable(),
  grantedBy: z.string().uuid().nullable(),
  note: z.string().nullable(),
  createdAt: z.string().datetime(),
});
export type CreditLedgerEntry = z.infer<typeof CreditLedgerEntrySchema>;

export const UserWithPlanSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  displayName: z.string().nullable(),
  isAdmin: z.boolean(),
  createdAt: z.string().datetime(),
  plan: UserPlanSchema,
});
export type UserWithPlan = z.infer<typeof UserWithPlanSchema>;

// Credit costs — flat rates per action
export const CREDIT_COSTS = {
  resumeGeneration: 10,
  bulletRewrite: 2,
  jobExtraction: 3,
  embeddingRefresh: 1,
} as const;
